import { Select } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useCallback } from "react";

const useStyles = makeStyles((theme) => ({
  select: {
    width: "120px",
  },
}));

export interface DropDownData {
  data: Data[];
  onChange: (term: string) => void;
}
export interface Data {
  key: string;
  value: string;
}

export const DropDown: React.FC<DropDownData> = ({ data, onChange }) => {
  const classes = useStyles();

  const handleSearch = useCallback(
    (event: any) => {
      onChange(event.target.value);
    },
    [onChange]
  );

  return (
    <Select className={classes.select} native onChange={handleSearch}>
      <option value={""}>No Selection</option>
      {data.map((v, index) => (
        <option key={index} value={v.value}>
          {v.value}
        </option>
      ))}
    </Select>
  );
};
